export default {
  label: 'CPF',
  hint: 'Banca ta are nevoie de CPF-ul tău pentru această plată. Îl transmitem mai departe și nu îl păstrăm.',
  invalid: 'Acesta nu este un CPF valid. Verifică cele 11 cifre.',
};
